import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import CryptoJS from 'crypto-js'
import { CYS } from './Secret'

import { API_URL } from './config'

export const createCryptoBaseQuery = ({
    getCurrentAccessToken,
}) => {

    const rawBaseQuery = fetchBaseQuery({
        baseUrl: API_URL,
        prepareHeaders: (headers) => {
            const token = getCurrentAccessToken()
            if (token) {
                headers.set('Authorization', `${token}`)
            }
            return headers
        },
    })

    return async (args, api, extraOptions) => {
        let modifiedArgs =
            typeof args === 'string' ? { url: args } : { ...args }

        if (modifiedArgs.body && !(modifiedArgs.body instanceof FormData)) {
            console.log(modifiedArgs.body)
            modifiedArgs.body = {
                cypher: CryptoJS.AES.encrypt(
                    JSON.stringify(modifiedArgs.body),
                    CYS
                ).toString(),
            }
        }

        let result = await rawBaseQuery(modifiedArgs, api, extraOptions)

        if (result.data && result.data.data) {
            try {
                const encrypted = result.data.data
                    ; result.data.data = JSON.parse(
                        CryptoJS.AES.decrypt(encrypted, CYS).toString(
                            CryptoJS.enc.Utf8
                        )
                    )
            } catch (err) {
                console.error('Decryption failed:', err)
            }
        }

        if (result.error) {
            if (result.error.status === 401 || result.error.status === 403) {
                // logout('login')
            }
        }

        return result
    }
}